<template>
  <div class="app-title">
    <p class="main-title">{{main}}</p>
    <p v-if="sub" class="sub-title">{{sub}}</p>
  </div>
</template>
<script>
export default {
  props: {
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .app-title{
    color:$base-font-color;
    .main-title{
      font-size:40px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      line-height:56px;
    }
    .sub-title{
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      line-height:22px;
      margin-top: 10px;
    }
  }
</style>
